import { render, staticRenderFns } from "./NewComments.vue?vue&type=template&id=a591e100&scoped=true"
import script from "./NewComments.vue?vue&type=script&lang=js"
export * from "./NewComments.vue?vue&type=script&lang=js"
import style0 from "./NewComments.vue?vue&type=style&index=0&id=a591e100&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a591e100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a591e100')) {
      api.createRecord('a591e100', component.options)
    } else {
      api.reload('a591e100', component.options)
    }
    module.hot.accept("./NewComments.vue?vue&type=template&id=a591e100&scoped=true", function () {
      api.rerender('a591e100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NewComments.vue"
export default component.exports